import * as React from 'react';
import * as FontAwesome from 'react-fontawesome';
import { connect, Dispatch } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import Table from '../../components/table/table';
import { DataType, RowObject, Tbody } from '../../components/table/tableModels';
import { ApplicationState } from '../../data/applicationStates';
import { headerActionCreators } from '../../data/header/headerActions';
import { HeaderState } from '../../data/header/headerModels';
import { newsActionCreators } from '../../data/news/newsActions';
import { ApiNewsState /* ApiNewsObject */ } from '../../data/news/newsModels';
import { projectsActionCreators } from '../../data/projects/projectsAction';
import { ProjectsState } from '../../data/projects/projectsModels';
import './designProjects.css';
// const designproject = require('../../resources/duct-design.png');
// tslint:disable-next-line:no-var-requires
const ductDesign = require('../../resources/duct-design.png');
// import * as shortId from 'shortid';
// tslint:disable-next-line:no-var-requires
const moment = require('moment');
// require('moment/locale/sv');

interface DesignState {
    projects: ProjectsState;
    news: ApiNewsState;
    header: HeaderState;
}

interface DesignActions {
    projectsAction: typeof projectsActionCreators;
    newsActions: typeof newsActionCreators;
    headerActions: typeof headerActionCreators;
}

type DesignProps = DesignState & // ... state we've requested from the Redux store
    DesignActions & // ... plus action creators we've requested
    RouteComponentProps<{}>; // ... plus incoming routing parameters

interface State {
    tHead: Array<RowObject>;
    projectList: Array<Tbody>;
}

class DesignProjects extends React.Component<DesignProps, State> {
    constructor(props: DesignProps) {
        super(props);
        this.state = {
            tHead: [
                new RowObject(DataType.string, 'Project Name', undefined, undefined, 'pointer'),
                new RowObject(DataType.string, 'Project Status', undefined, undefined, 'pointer'),
                new RowObject(DataType.string, 'Est. Completion Date', undefined, undefined, 'pointer'),
                new RowObject(DataType.string, 'Project Number', undefined, undefined, 'pointer')
            ],
            projectList: []
        };
        this.getTbody = this.getTbody.bind(this);
    }

    getTheProject(id: string) {
        this.props.history.push('/ductdesignproject/' + id);
    }

    componentWillMount() {
        this.props.headerActions.setBottomHeader('My Quick Solutions Online');
        this.getTbody(this.props);
    }

    componentDidUpdate(prevProps: DesignProps) {
        if (this.props.projects.projects !== prevProps.projects.projects) {
            this.getTbody(this.props);
        }
    }

    getTbody(props: DesignProps) {
        let projectList = new Array<Tbody>();

        projectList = props.projects.projects.map((data) => {
            const rBody = new Array<RowObject>();

            rBody.push(new RowObject(DataType.string, data.name ? data.name : '', null, undefined, undefined));

            rBody.push(
                new RowObject(DataType.string, data.projectStatus ? data.projectStatus : '', null, undefined, undefined)
            );

            rBody.push(
                new RowObject(
                    DataType.string,
                    data.estCompletionDate ? moment(data.estCompletionDate).format('M/D/YYYY') : '',
                    null,
                    undefined,
                    undefined
                )
            );

            rBody.push(
                new RowObject(DataType.string, data.projectNumber ? data.projectNumber : '', null, undefined, undefined)
            );
            const row = new Tbody(rBody, data.projectNumber, this.getTheProject.bind(this));

            return row;
        });
        this.setState({ projectList: projectList });
    }

    public render() {
        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="componentHeader">
                        <div className="item tile">
                            <div className="tileHead">
                                <div className="float-left">
                                    <h4>{'Design Projects'}</h4>
                                </div>
                                <div className="tileImage float-right">{<img src={ductDesign} />}</div>
                            </div>
                            <div className="tileBody">
                                <div className="topBorder" />
                            </div>
                        </div>
                    </div>
                </div>
                {this.state.projectList.length > 0 ? (
                    <Table
                        tHead={this.state.tHead}
                        tBody={this.state.projectList}
                        listSize={this.props.projects.projects.length}
                        hover={true}
                        hidePagination={true}
                        americanDateFormat={true}
                    />
                ) : (
                    <div className="centerThis">
                        <FontAwesome className="progressicon" name="spinner" size="3x" spin={true} />
                    </div>
                )}
            </div>
        );
    }
}

export function mapStateToProps(state: ApplicationState): DesignState {
    return {
        projects: state.projects,
        news: state.news,
        header: state.header
    };
}

function mapDispatchToProps(dispatch: Dispatch<{}>): DesignActions {
    return {
        projectsAction: bindActionCreators(projectsActionCreators, dispatch),
        newsActions: bindActionCreators(newsActionCreators, dispatch),
        headerActions: bindActionCreators(headerActionCreators, dispatch)
    };
}

export default withRouter(
    connect(
        mapStateToProps, // Selects which state properties are merged into the component's props
        mapDispatchToProps // Selects which action creators are merged into the component's props
    )(DesignProjects)
);



// WEBPACK FOOTER //
// ./src/containers/designProjects/designProjects.tsx